import React from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Button, Col, Form, Row, InputGroup, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import { nationalities } from '../../../config'

moment.locale("fr", {
  months:
    "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
      "_"
    ),
  monthsShort:
    "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
  monthsParseExact: true,
  weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
  weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm",
  },
  calendar: {
    sameDay: "[Aujourd’hui à] LT",
    nextDay: "[Demain à] LT",
    nextWeek: "dddd [à] LT",
    lastDay: "[Hier à] LT",
    lastWeek: "dddd [dernier à] LT",
    sameElse: "L",
  },
  relativeTime: {
    future: "dans %s",
    past: "il y a %s",
    s: "quelques secondes",
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans",
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function (number) {
    return number + (number === 1 ? "er" : "e");
  },
  meridiemParse: /PD|MD/,
  isPM: function (input) {
    return input.charAt(0) === "M";
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function (hours, minutes, isLower) {
    console.log(minutes, isLower);
    return hours < 12 ? "PD" : "MD";
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // Used to determine first week of the year.
  },
});

const Newucrm = ({canRedirect = true, redirectHere = () => {}}) => {
  registerLocale('fr', fr);
  setDefaultLocale('fr');
  const [valueBooking, setValueBooking] = React.useState(null);
  const [validated, setValidated] = React.useState(false);
  const [formd, setFrom] = React.useState({ type: "physique" });
  const [l, setL] = React.useState(false);
  const [is_moral, setMoral] = React.useState(false);
  const [is_owner, setIs_Owner] = React.useState(false);
  const [is_intendances, setIs_intendances] = React.useState(false);
  const [valueIntendance, setValueIntendance] = React.useState([]);
  const [valueVilla, setValueVilla] = React.useState([]);
  const [villas, setVilla] = React.useState([]);
  const [mailingsList, setMailingsList] = React.useState([]);
  const [valueMailList, setValueMailList] = React.useState([]);
  const [preferences, setPreferences] = React.useState([]);

  const [reservations, setReservations] = React.useState([]);
  const [valueLang, setValueLang] = React.useState(null);


  const [picture_profile, setPictureProfile] = React.useState(null);
  const [files_id, setFileId] = React.useState([]);
  const [kbis, setKbis] = React.useState(null);
  const [rib, setRib] = React.useState(null);

  const navigate = useNavigate();




  const loadBooking = () => {
    firebase.firestore().collection('bookings').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.origin?.label ? l?.origin?.label : "Inconnu"} - ${l?.property?.label ? l?.property?.label : "Inconnu"} - ${moment(l?.checkin?.toDate()).format('DD/MM/YYYY')}` }
          s.push(dr)
        }

      })
      setReservations(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  function generateString(length) {
    let result = '';
    const charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  const sendFile = async (file, cb) => {
    const storage = firebase.storage();
    const metadata = {
      contentType: file.type,
    };

    const ss = `files/${generateString(10)}.${file?.type?.split("/")[1]}`;
    const reference = storage.ref(ss);


    const uploadTask = reference.put(file, metadata);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress}% done`);
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (err) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (err.code) {
          case "storage/unauthorized":
            console.error("err", err)
            // User doesn't have permission to access the object
            alert(
              "Une erreur est survenue lors de l'envoie de votre fichier, vous n'avez pas l'autorisation d'envoyez des documents."
            );
            break;
          case "storage/canceled":
            // User canceled the upload alert(
            alert(
              "Une erreur est survenue lors de l'envoie de votre fichier, vous avez annuler l'envoie."
            );
            break;

          // ...

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            alert(
              "Une erreur est survenue lors de l'envoie de votre fichier, réessayer plus tard."
            );
            break;
          default:
            break;
        }
      },
      () => {
        console.log("Image uploaded to the bucket!");



        uploadTask.snapshot.ref
          .getDownloadURL()
          .then(async (downloadURL) => {
            cb(downloadURL)
          });
      }
    );


  };


  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      alert("Un champs est invalide ou manquant")
      return;
    } 
    

    let p = { ...formd } 

    delete p?.files_id_update;
    delete p?.kbis_update;
    delete p?.rib_update;
    delete p?.picture_profile_update;

 
    setValidated(true);
    setL(true);
    p.create_At = new Date();
    p.update_At = new Date();
    console.log('p', p)
    firebase.firestore().collection('crm').add(p).then(async (m) => {
      // console.log("Document successfully written!");
      if (formd?.kbis_update) {
        await sendFile(formd?.kbis_update, async (downloadURL) => {
          firebase.firestore().collection('crm').doc(m.id).update({ kbis_file: downloadURL })
        });
      }
      if (formd?.rib_update) {
        await sendFile(formd?.rib_update, async (downloadURL) => {
          firebase.firestore().collection('crm').doc(m.id).update({ rib_file: downloadURL })
        });
      }
      if (formd?.picture_profile_update) {
        await sendFile(formd?.picture_profile_update, async (downloadURL) => {
          firebase.firestore().collection('crm').doc(m.id).update({ picture_profile: downloadURL })
        });
      }

      if (formd?.files_id_update?.length > 0) {
        var ng = [];
        var index = 0;
        Array.from(formd?.files_id_update).forEach(async (n) => {
          await sendFile(n, async (downloadURL) => {
            ng.push(downloadURL)
            index += 1;
            if (index === formd?.files_id_update.length) {
              firebase.firestore().collection('crm').doc(m.id).update({ files_id: ng })
            }
          });
        })
      }
      toast.success("Client créer avec succès, chargement ...");
      if (formd.property?.length > 0) {
        toast.success("Assignation des propriétés au nouveau propriétaire, chargement ...");
        // on va scanner les propriétés et ajouter l'identifiant a ownerId de la propriété 
        const updates = formd.property
          ?.filter(ps => ps.value) // Filtrer uniquement les valeurs non nulles
          .map(ps =>
            firebase.firestore().collection('properties').doc(ps.value).update({
              ownerId: m.id,
              _update_At: new Date(),
            })
          );

        if (updates?.length > 0) {
          Promise.all(updates)
            .then(() => console.log("Mises à jour effectuées avec succès"))
            .finally(() => { 
              redirectN(m.id);
            })
            .catch(error => console.error("Erreur lors des mises à jour :", error));
        } else {
          redirectN(m.id);
        }
      } else {
        redirectN(m.id);
      }

    }).catch((error) => {
      setL(false);
      setValidated(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })

  };
  
  const redirectN = (id) => {
    if (canRedirect === false){ 
      redirectHere({
        value: id,
        label : `${formd.lastName} ${formd.firstName}`,
        email : formd.email,
      })
    }else{
      navigate('/crm/edit/' + id);
    }
    
  }

  const loadVilla = () => {
    firebase.firestore().collection('properties').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.nameHouse}` }
          s.push(dr)
        }

      })
      setVilla(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }
  const loadMailingsList = () => {
    firebase.firestore().collection('mailingslist').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete) {
          // supprimer donc ne pas affiché
        } else {
          const dr = { value: d.id, label: `${l?.title}` }
          s.push(dr)
        }

      })
      setMailingsList(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  const handleChange = e => {
    let d = { ...formd };
    d[e.target.name] = e.target.value
    if (e.target.name === "is_owner") {
      d[e.target.name] = e.target.checked;
      setIs_Owner(e.target.checked)
    }



    if (e.target.name === "is_intendances") {
      d[e.target.name] = e.target.checked;
      setIs_intendances(e.target.checked);
    }
    if (e.target.name === "type") {
      d[e.target.name] = e.target.value === "moral" ? "moral" : "physique";
      setMoral(e.target.value === "moral")
    }
    setFrom(d);
  };
  React.useEffect(() => {
    loadVilla();
    loadBooking();
    loadMailingsList();
  }, [])
  const NationalityField = ({ value, onChange }) => {


    return (
      <Form.Group as={Col} md="3" controlId="nationality">
        <Form.Label>Nationalité</Form.Label>
        <Form.Control
          as="select"
          name="nationality"
          value={value || ''}
          onChange={onChange}
        >
          <option value="">Sélectionnez une nationalité</option>
          {nationalities.map((nat, index) => (
            <option key={index} value={nat}>
              {nat}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Nationalité invalide.
        </Form.Control.Feedback>
      </Form.Group>
    );
  };

  return (
    <FalconComponentCard>
      <FalconComponentCard.Header title="Nouveau Client" light={false} noPreview={true} />
      <FalconComponentCard.Body >
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Check
              name="gender"
              type="radio"
              value="male"
              onChange={handleChange}
              label="Homme"
            />
            <Form.Check
              name="gender"
              type="radio"
              value="female"
              onChange={handleChange}
              label="Femme"
            />
          </Form.Group>
          <Form.Group controlId="formFile" className="mb-3" as={Col} md="8"  >
            <Form.Label>Photo de profile</Form.Label>
            <Form.Control type="file" name="picture_profile" accept="image/png, image/gif, image/jpeg"
              onChange={(value) => {
                setPictureProfile(value?.target?.files)
                let d = { ...formd };
                d.picture_profile_update = value?.target?.files[0]
                setFrom(d);

              }} />

          </Form.Group>

          <Form.Group controlId="lang" className="mb-3" as={Col} md="4"  >
            <Form.Label>Préférence langue</Form.Label>
            <Select
              // closeMenuOnSelect={false} 
              options={[{ value: "fr", label: "Français" }, { value: "en", label: "Anglais" }]}
              placeholder='Chosir la langue'
              classNamePrefix="react-select"
              value={valueLang}
              onChange={value => {
                setValueLang(value)
                let d = formd;
                d['lang'] = value;
                setFrom(d);
              }}
            />
          </Form.Group>
          <Form.Group controlId="origin" className="mb-3" as={Col} md="6"  >
            <Form.Label>Origine</Form.Label>
            <Form.Control
              onChange={handleChange}
              name="origin"
              type="text"
              placeholder="Origine"
            />
          </Form.Group>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="exampleFirstName">
              <Form.Label>Prénom</Form.Label>
              <Form.Control
                onChange={handleChange}
                name="firstName"
                type="text"
                placeholder="Prénom"
              />
              <Form.Control.Feedback type="invalid">
                Veuillez indiquez votre Prénom.
              </Form.Control.Feedback>
              <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="exampleLastName">
              <Form.Label>Nom de famille</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                onChange={handleChange}
                placeholder="Nom de famille"
              />
              <Form.Control.Feedback type="invalid">
                Veuillez indiquez votre nom de famille.
              </Form.Control.Feedback>
              <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="exampleUserName">
              <Form.Label>Email</Form.Label>
              <InputGroup hasValidation>
                <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email"
                  aria-describedby="inputGroupPrepend"
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  Veuillez indiquez l'email.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="3" controlId="phone">
              <Form.Label>Téléphone (+XXX international)</Form.Label>
              <Form.Control
                name="phone"
                onChange={handleChange} type="phone" placeholder="Téléphone" />
              <Form.Control.Feedback type="invalid">
                Téléphone invalide.
              </Form.Control.Feedback>
            </Form.Group>
            <NationalityField value={formd?.nationality} onChange={(v) => {

              let d = { ...formd };
              d["nationality"] = v.target.value
              setFrom(d)
            }} />
            {/* <Form.Group as={Col} md="3" controlId="nationality">
                    <Form.Label>Nationalité</Form.Label>
                    <Form.Control 
                    name="nationality"
                    onChange={handleChange} type="text" placeholder="Nationalité"  />
                    <Form.Control.Feedback type="invalid">
                        Nationalité invalide.
                    </Form.Control.Feedback>
                </Form.Group>  */}


            <Form.Group as={Col} md="3" controlId="birthday">
              <Form.Label>Date de naissance</Form.Label>
              <Form.Control
                name="birthday"
                type="date"
                onChange={handleChange} placeholder="Date de naissance" />
              <Form.Control.Feedback type="invalid">
                Date de naissance invalide.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="adresse">
              <Form.Label>Adresse</Form.Label>
              <Form.Control
                type="text"
                value={formd.adresse}
                name="adresse"
                onChange={handleChange}
                placeholder="Adresse ..."
              />
            </Form.Group>
            <Form.Group as={Col} md="3" controlId="city">
              <Form.Label>Ville</Form.Label>
              <Form.Control
                type="text"
                value={formd.city}
                name="city"
                onChange={handleChange}
                placeholder="Ville ..."
              />
            </Form.Group>

            <Form.Group as={Col} md="2" controlId="zipcode">
              <Form.Label>Code postale</Form.Label>
              <Form.Control
                type="text"
                value={formd.zipcode}
                name="zipcode"
                onChange={handleChange}
                placeholder="Code postale ..."
              />
            </Form.Group>
            <Form.Group as={Col} md="2" controlId="country">
              <Form.Label>Pays</Form.Label>
              <Form.Control
                type="text"
                value={formd.country}
                name="country"
                onChange={handleChange}
                placeholder="Pays ..."
              />
            </Form.Group>

            <Form.Group as={Col} md="10" controlId="complement">
              <Form.Label>Complément d'adresse</Form.Label>
              <Form.Control
                type="text"
                value={formd.complement}
                name="complement"
                onChange={handleChange}
                placeholder="Complément d'adresse ..."
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group controlId="formFileMultiple" className="mb-3" >
              <Form.Label>Pièce d'identité (recto & verso)</Form.Label>
              <Form.Control type="file" multiple name="files_id" accept="image/png, image/gif, image/jpeg, application/pdf"
                onChange={(value) => {
                  setFileId(value?.target?.files)
                  let d = { ...formd };
                  d.files_id_update = value?.target?.files
                  setFrom(d);
                  console.log("files_id_update", d)
                }}
              />
            </Form.Group>
          </Row>





          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              name="is_owner"
              onChange={handleChange}
              label="C'est un propriétaire"
            />

          </Form.Group>

          {/* {formd.is_owner && (
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="selectVilla">
                <Form.Label>Chosir les biens du propriétaire</Form.Label>

                <Select
                  closeMenuOnSelect={false}
                  options={villas}
                  isMulti
                  placeholder='Chosir les biens du propriétaire...'
                  classNamePrefix="react-select"
                  value={valueVilla}
                  onChange={value => {
                    setValueVilla(value)
                    let d = formd;
                    d['property'] = value;
                    setFrom(d);

                  }}
                />
              </Form.Group>
            </Row>

          )} */}

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              name="is_locataire"
              onChange={handleChange}
              label="C'est un locataire"
              checked={formd.is_locataire}
            />
            {/* <p>{formd.is_owner}</p> */}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              name="is_intendances"
              onChange={handleChange}
              label="C'est un intendant"
              checked={formd.is_intendances}
            />
            {/* <p>{formd.is_owner}</p> */}
          </Form.Group>
          {formd.is_intendances && (
            <Row className="mb-3">
              <Form.Group as={Col} md="4" controlId="intendancerole">
                <Form.Label>Rôle d'intendant</Form.Label>
                <Form.Control
                  type="text"
                  name="intendance"
                  onChange={handleChange}
                  placeholder="Jardinier, Cuisinier, consierge, ..."
                  value={formd.intendance}
                />
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="intendancesPid">
                <Form.Label>Chosir les biens lié à l'intendances</Form.Label>

                <Select
                  closeMenuOnSelect={false}
                  options={villas}
                  isMulti
                  placeholder="Chosir les biens de l'intendances..."
                  classNamePrefix="react-select"
                  value={valueIntendance}
                  onChange={value => {
                    setValueIntendance(value)
                    let d = formd;
                    d['intendancesPid'] = value;
                    setFrom(d);

                  }}
                />
              </Form.Group>
            </Row>

          )}

          <Row className="mb-3">
            <Form.Group className="mb-3">
              <p>Type de compte</p>
              <Form.Check
                name="type"
                type="radio"
                value="physique"
                checked={!is_moral}
                onChange={handleChange}
                label="Personne physique"
              />
              <Form.Check
                name="type"
                type="radio"
                value="moral"
                checked={is_moral}
                onChange={handleChange}
                label="Personne morale"
              /></Form.Group>
          </Row>
          {is_moral && (
            <>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="businessName">
                  <Form.Label>Nom de la société</Form.Label>
                  <Form.Control
                    type="text"
                    name="businessName"
                    onChange={handleChange}
                    placeholder="Nom de la société"
                    value={formd.businessName}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="representBy">
                  <Form.Label>Représentant</Form.Label>
                  <Form.Control
                    type="text"
                    name="representBy"
                    onChange={handleChange}
                    placeholder="Représenté par"
                    value={formd.representBy}
                  />
                </Form.Group>



                <Form.Group as={Col} md="6" controlId="businessAdresse">
                  <Form.Label>Adresse</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.businessAdresse}
                    name="businessAdresse"
                    onChange={handleChange}
                    placeholder="Adresse ..."
                  />
                </Form.Group>
                <Form.Group as={Col} md="3" controlId="businessCity">
                  <Form.Label>Ville</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.businessCity}
                    name="businessCity"
                    onChange={handleChange}
                    placeholder="Ville ..."
                  />
                </Form.Group>

                <Form.Group as={Col} md="2" controlId="businessZipcode">
                  <Form.Label>Code postale</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.businessZipcode}
                    name="businessZipcode"
                    onChange={handleChange}
                    placeholder="Code postale ..."
                  />
                </Form.Group>

                <Form.Group as={Col} md="2" controlId="businessCountry">
                  <Form.Label>Pays</Form.Label>
                  <Form.Control
                    type="text"
                    value={formd.businessCountry}
                    name="businessCountry"
                    onChange={handleChange}
                    placeholder="Pays ..."
                  />
                </Form.Group>

              </Row>



              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="siren">
                  <Form.Label>Numéro de siren</Form.Label>
                  <Form.Control
                    type="text"
                    name="siren"
                    onChange={handleChange}
                    placeholder="Numéro de siren"
                    value={formd.siren}
                  />
                </Form.Group>
                <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="8"  >
                  <Form.Label>KBis ou avis siren</Form.Label>
                  <Form.Control type="file" name="kbis_file"
                    onChange={(value) => {
                      setKbis(value?.target?.files)
                      let d = { ...formd };
                      d.kbis_update = value?.target?.files[0]
                      setFrom(d);
                      console.log("kbis_update", d)
                    }}
                  />
                </Form.Group>
              </Row>
            </>
          )}
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="iban">
              <Form.Label>Numéro de compte (IBAN)</Form.Label>
              <Form.Control
                type="text"
                name="iban"
                onChange={handleChange}
                placeholder="Numéro de compte (IBAN)"
              />
            </Form.Group>

            <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="8"  >
              <Form.Label>IBAN (fichier)</Form.Label>
              <Form.Control type="file" name="RIB_file"
                onChange={(value) => {
                  setRib(value?.target?.files)
                  let d = { ...formd };
                  d.rib_update = value?.target?.files[0]
                  setFrom(d);
                  console.log("rib_update", d)
                }} />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="7" controlId="bookingorder">
              <Form.Label>Assigné les réservations précédente</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={reservations}
                placeholder='Select...'
                isMulti
                classNamePrefix="react-select"
                value={valueBooking}
                onChange={value => {
                  setValueBooking(value)
                  let d = { ...formd };
                  d.bookingList = value
                  setFrom(d);
                  console.log("bookingList_update", d)

                }}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="emailingList">
              <Form.Label>Liste d'emailing</Form.Label>

              <Select
                autocomplete="off"
                closeMenuOnSelect={false}
                options={mailingsList}
                placeholder='Choisir...'
                isMulti
                classNamePrefix="react-select"
                value={valueMailList}
                onChange={value => {
                  setValueMailList(value)
                  let d = { ...formd };
                  d.mailingsList = value
                  setFrom(d);
                  console.log("mailingsList_update", d)
                }}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Label>Préférences</Form.Label>
            {
              preferences.map((pref, index) => {
                return (<Row className="mb-3">
                  <Form.Group as={Col} md="10" className="mb-3">
                    <Form.Control
                      name={`pref_${index}`}
                      placeholder="Préférence"
                      value={pref}
                      onChange={(e) => {
                        let o = [...preferences];
                        o[index] = e.target.value;
                        setPreferences(o);
                        let d = { ...formd };
                        d['preferences'] = o;
                        setFrom(d);
                      }}
                    />
                  </Form.Group>

                  <IconButton as={Col} md="1" onClick={() => {
                    let arr = preferences;
                    arr.splice(index, 1);
                    setPreferences(arr);
                    let d = { ...formd };
                    d['preferences'] = arr;
                    setFrom(d);
                  }}
                    variant="falcon-danger"
                    size="sm"
                    icon="trash"
                    transform="shrink-3"
                    className='me-2'
                    style={{ width: 60, height: 25 }}
                  >
                  </IconButton>
                </Row>)
              })
            }

            <div>
              <Flex
                alignItems="center"
                className="mb-4 text-primary cursor-pointer fs-0"
                onClick={() => {
                  let o = [...preferences];
                  if (o[o.length - 1]?.trim() !== "") {
                    o.push("");
                    setPreferences(o);
                  }
                }}
              >
                <span className="circle-dashed">
                  <FontAwesomeIcon icon="plus" />
                </span>
                <span className="ms-3">Ajouter une nouvelle préférence</span>
              </Flex>
            </div>




          </Row>


          <hr className="mt-3" />


          <Form.Group as={Col} md="3" controlId={`first_date`}>
            <Form.Label>Date du premier contact </Form.Label>
            <Form.Control
              name="first_date"
              type="date"
              onChange={handleChange} placeholder="du premier contact" />

            {/* <DatePicker
                    selected={first_date} 
                    dateFormat="dd/MM/yyyy"
                    onChange={newDate => {
                        let d = {...formd};
                        d['first_date'] = newDate;
                        setFrom(d)
                        console.log("ici", d)
                        setFirstDate(newDate) 
                    }}
                    customInput={
                        <CustomDateInput
                        formControlProps={{
                            placeholder: 'jj/mm/yy',
                        //     ...register(`ScheduleStartDate${index}`)
                        }}
                        />
                    }
                    /> */}
          </Form.Group>

          {/* parain */}
          <hr />

          <Row>
            <h5>
              Information sur le parrain
            </h5>

            <Row className="mb-3">
              <Form.Group as={Col} md="4" controlId="exampleFirstNameparrain">
                <Form.Label>Prénom</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name="firstNameparain"
                  minlength="3"
                  type="text"
                  placeholder="Prénom du parrain"
                />
                <Form.Control.Feedback type="invalid">
                  Veuillez indiquez votre Prénom.
                </Form.Control.Feedback>
                <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="exampleLastNameparrain">
                <Form.Label>Nom de famille</Form.Label>
                <Form.Control
                  minlength="3"
                  type="text"
                  name="lastNameparrain"
                  onChange={handleChange}
                  placeholder="Nom de famille du parrain"
                />
                <Form.Control.Feedback type="invalid">
                  Veuillez indiquez votre nom de famille.
                </Form.Control.Feedback>
                <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="exampleUserName">
                <Form.Label>Email</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                  <Form.Control
                    type="email"
                    name="emailparrain"
                    placeholder="Email"
                    aria-describedby="inputGroupPrepend"
                    onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Veuillez indiquez l'email.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="3" controlId="phone">
                <Form.Label>Téléphone</Form.Label>
                <Form.Control
                  name="phoneparrain"
                  onChange={handleChange} type="phone" placeholder="Téléphone" minlength="10" />
                <Form.Control.Feedback type="invalid">
                  Téléphone invalide.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="origin" className="mb-3" as={Col} md="6"  >
                <Form.Label>Origine</Form.Label>
                <Form.Control
                  onChange={handleChange}
                  name="originparrain"
                  minlength="3"
                  type="text"
                  placeholder="Origine"
                />
              </Form.Group>
              <Form.Group as={Col} md="3" controlId="parraindate">
                <Form.Label>Date de mise en relation</Form.Label>
                <Form.Control
                  name="parraindate"
                  type="date"
                  onChange={handleChange} placeholder="Date de mise en relation" />
                <Form.Control.Feedback type="invalid">
                  Date de mise en relation invalide.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Row>
          <hr />
          <Row className="mb-3">
            <Form.Label>Commentaire</Form.Label>
            <Form.Group className="mb-3">

              <Form.Control as="textarea" name="comment"
                placeholder="Laisser un commentaire ici"
                onChange={handleChange}
                style={{ height: '100px' }}
              />
            </Form.Group>

          </Row>
          <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Créer'}</Button>
        </Form>
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
  //   <> 

  //     <FalconComponentCard>
  //       
  //       <FalconComponentCard.Body code={exampleCode} language="jsx" />
  //     </FalconComponentCard> 
  //   </>
};

export default Newucrm;
